/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_LINK(state, link) {
    var valid_links = []

    // Add height attribute
    try {
      if (JSON.parse(link.hobjects[0].abilities).skin != undefined) {
        link.hobjects[0].height = JSON.parse(link.hobjects[0].abilities).skin.height
      } else if (JSON.parse(link.hobjects[0].abilities).gltf_loader != undefined) {
        link.hobjects[0].height = JSON.parse(link.hobjects[0].abilities).gltf_loader.height
      } else {
        link.hobjects[0].height = JSON.parse(link.hobjects[0].abilities).skin.height
      }
    } catch (error) {
      link.hobjects[0].height = 1
    }

    // If image does not have an original_image ann one from sourceUrl
    if (!link.hobjects[0].original_image) {
      try {
        link.hobjects[0].original_image = JSON.parse(link.hobjects[0].abilities).skin.source_url
      } catch (error) {
        console.log(error)
      }
    }

    // If hobject is hoverlay.art.WallArt.1.0 add it to the list of links
    if (
      link.hobjects[0].model_identifier == 'hoverlay.art.WallArt.1.0' &&
      (link.hobjects[0].original_image != null || link.hobjects[0].asset_url != null)
    )
      valid_links.push(link)

    const index = state.links.findIndex(p => p.hobjects[0].pid === link.hobjects[0].pid)
    if (index < 0) state.links.push(link)
    else Object.assign(state.links[index], link)
  },
  SET_LINK(state, links) {
    var valid_links = []
    links.forEach(element => {
      // Add height attribute
      try {
        element.hobjects[0].height = JSON.parse(element.hobjects[0].abilities).skin.height
      } catch (error) {
        element.hobjects[0].height = 1
        console.log(error)
      }

      // If image does not have an original_image ann one from sourceUrl
      if (!element.hobjects[0].original_image) {
        try {
          element.hobjects[0].original_image = JSON.parse(element.hobjects[0].abilities).skin.source_url
        } catch (error) {
          console.log(error)
        }
      }
      // If hobject is hoverlay.art.WallArt.1.0 add it to the list of links
      if (
        (element.hobjects[0].model_identifier == 'hoverlay.art.WallArt.1.0' ||
          element.hobjects[0].model_identifier == 'hoverlay.core.3dModel.1.0') &&
        (element.hobjects[0].original_image != null || element.hobjects[0].asset_url != null)
      )
        valid_links.push(element)
    })
    if (links) {
      state.links = valid_links
    }
  },
  UPDATE_LINK(state, link) {
    const index = state.links.findIndex(p => p.hobjects[0].pid === link.hobjects[0].pid)
    Object.assign(state.links[index], link)
  },
  REMOVE_LINK(state, linkPid) {
    const lPid = state.links.findIndex(p => p.pid === linkPid)
    state.links.splice(lPid, 1)
  },
  ADD_HOBJECT(state, hobject) {
    state.hobjects.unshift(hobject)
  },
  SET_HOBJECT(state, hobjects) {
    if (hobjects) state.hobjects = hobjects
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_HOBJECT(state, hobject) {
    const hobjectPid = state.hobjects.findIndex(p => p.pid === hobject.pid)

    let height = null

    var abilities
    if (hobject.model_identifier == 'hoverlay.art.WallArt.1.0') {
      try {
        abilities = JSON.parse(hobject.abilities)
        height = abilities.skin.height
      } catch (error) {
        console.log(error)
        height = 1
      }
    }

    if (hobject.model_identifier == 'hoverlay.core.3dModel.1.0') {
      try {
        abilities = JSON.parse(hobject.abilities)
        height = abilities.gltf_loader.height
      } catch (error) {
        height = null
        console.log(error)
      }
    }

    hobject.height = height
    console.log(hobject)
    Object.assign(state.hobjects[hobjectPid], hobject)
  },
  REMOVE_HOBJECT(state, hobjectPid) {
    const hPid = state.hobjects.findIndex(p => p.pid === hobjectPid)
    state.hobjects.splice(hPid, 1)
  },
}
